import { actionTypes } from '../../../types';

export const uploadReferenceVideo = (payload, callback) => ({
    type: actionTypes.UPLOAD_REFERENCE_VIDEO_REQUEST,
    payload,
    callback,
});

export const uploadReferenceVideoSuccess = (payload) => ({
    type: actionTypes.UPLOAD_REFERENCE_VIDEO_SUCCESS,
    payload,
});

export const uploadReferenceVideoFailure = (payload) => ({
    type: actionTypes.UPLOAD_REFERENCE_VIDEO_FAILURE,
    payload,
});

export const uploadReferenceVideoReset = () => ({
    type: actionTypes.UPLOAD_REFERENCE_VIDEO_RESET,
});

export const uploadReferenceVideoResetAll = () => ({
    type: actionTypes.UPLOAD_REFERENCE_VIDEO_RESET_ALL,
});
